var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-sigin-protocol-wrapper",style:(_vm.iframeHeight)},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.htmlSrc,"frameborder":"0","name":"iframe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }